import { computed } from 'vue';
import { useNutzInputStore } from '@/features/Sparten/nutz/useInputStore';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';

export const hasNutzKilometerstand = computed(
  (): boolean =>
    useNutzInputStore().allgemein !== undefined &&
    useNutzInputStore().allgemein.wkz !==
      WKZ.ANHAENGER_PRIVAT_UND_WERKVERKEHR &&
    useNutzInputStore().allgemein.wkz !== WKZ.ANHAENGER_GEWERBLICHER_VERKEHR,
);
